// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"afb25f13","239":"ba4d5576","455":"080026df"}[chunkId] + ".chunk.js";
};